import { Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

/**
 * Unknown routes redirect to the app root (smart landing / lobby).
 */
const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);

  return <Navigate to="/" replace />;
};

export default NotFound;
